import { combineReducers } from 'redux';
import searchQuery from './search-query';

export default combineReducers({
  searchQuery
});
